module.exports = __webpack_public_path__ + "static/media/US.ba5d44d1.svg";